export default function weightIcon(props) {
  return (
    <svg
      {...props}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="22.229"
      height="28.857"
      viewBox="0 0 1000 1000"
      enableBackground="new 0 0 1000 1000"
    >
      <g fill="#fff">
        <path d="M50.8,171.2C50.8,105,105,50.8,171.4,50.8h657.2c66.4,0,120.6,54.2,120.6,120.3v657.4c0,66.4-54.2,120.6-120.6,120.6H171.4C105,949.2,50.8,895,50.8,828.6V171.2z M171.4,990h657.2c89,0,161.4-72.4,161.4-161.4V171.2C990,82.4,917.6,10,828.6,10H171.2C82.4,10,10,82.4,10,171.2v657.4C10,917.6,82.4,990,171.4,990z" />
        <path d="M326.6,173.3c23.7,20.4,50.4,36.2,79,46.8l-41.4,82.8c-4.9,10.3-0.8,22.6,9.3,27.5c10,5.2,22.3,1.1,27.5-9l44.9-89.8c17.7,3.8,35.7,5.7,54.2,5.7c64.5,0,125.2-22.6,173.4-64L794,293.7c-80.6,73.5-184,113.8-294,113.8c-110,0-213.4-40.3-294-113.8L326.6,173.3z M500,448.3c127.7,0,247.4-49.6,337.5-139.6c7.9-8.2,7.9-21,0-28.9L688.4,130.6c-3.8-4.1-9.3-6-14.4-6c-5.2,0-10.3,1.9-14.4,6c-42.5,42.5-99.1,65.9-159.5,65.9c-60.4,0-117-23.4-159.5-65.9c-8.2-8.2-20.9-8.2-28.8,0L162.5,279.8c-8.2,7.9-8.2,20.7,0,28.9C252.3,398.7,372.3,448.3,500,448.3z" />
      </g>
    </svg>
  );
}
